import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export async function signInWithPassword(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password })
  return { data, error }
}

export async function signOut() {
  const { error } = await supabase.auth.signOut()
  return { error }
}

export async function getSession() {
  const { data: { session } } = await supabase.auth.getSession()
  return session
}

// Resolve a user's company_id from company_members by email (case-insensitive).
// Returns null if the user isn't yet in company_members.
export async function getUserCompanyId(email) {
  if (!email) return null
  const { data } = await supabase
    .from('company_members')
    .select('company_id')
    .ilike('email', email)
    .limit(1)
    .maybeSingle()
  return data?.company_id || null
}

// Load accountability map for a company
export async function loadMap(companyId) {
  if (!companyId) return { data: null, error: null }
  const { data, error } = await supabase
    .from('accountability_maps')
    .select('*')
    .eq('company_id', companyId)
    .maybeSingle()
  return { data, error }
}

// Save (upsert) accountability map for a company
export async function saveMap(companyId, mapData) {
  if (!companyId) return { data: null, error: new Error('No company_id') }
  const { data: { session } } = await supabase.auth.getSession()
  const userId = session?.user?.id
  const { data, error } = await supabase
    .from('accountability_maps')
    .upsert({
      company_id: companyId,
      user_id: userId,
      map_data: mapData,
      updated_at: new Date().toISOString()
    }, { onConflict: 'company_id' })
    .select()
    .maybeSingle()
  return { data, error }
}
